// Blender plugin runtime config. Lives next to the Blender client because
// these constants describe Blender's specific protocol surface — host, port,
// and the URLs derived from them. Future DCCs (Maya, 3ds Max, Unity, Unreal)
// will get their own sibling folders with their own config; they may share
// the same protocol shape if BE keeps it uniform across plugins, but we will
// only know that when each plugin actually ships.

export const BLENDER_PLUGIN_HOST = 'localhost'
export const BLENDER_PLUGIN_PORT = 49485

export const BLENDER_PLUGIN_WS_URL = `ws://${BLENDER_PLUGIN_HOST}:${BLENDER_PLUGIN_PORT}`
export const BLENDER_PLUGIN_HEALTH_URL = `http://${BLENDER_PLUGIN_HOST}:${BLENDER_PLUGIN_PORT}/health`
